const paginaintranet = {
    ObtenerContenidosDeIntranetAdministracion: 'SICPO/Intranet/PaginaIntranet/Navegacion/ObtenerPaginaConSeccionesYContenidos',
    ObtenerMenusDeIntranet: 'SICPO/Intranet/PaginaIntranet/Navegacion/ObtenerMenusDeIntranet',
    VerificarSiTieneHabilitadaPagina: 'SICPO/Intranet/PaginaIntranet/Navegacion/VerificarSiTieneHabilitadaPagina',
    GetModulos: 'SICPO/Intranet/PaginaIntranet/Navegacion/ObtenerModulosConPermisos'
}

export default paginaintranet;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/intranet/paginaIntranet/paginaIntranet.js
// module id = null
// module chunks = 